/**
 * TrendModa — Akıllı Arama + Keşfet Paneli
 * Boş inputta focus → Keşfet paneli (son aramalar + koleksiyonlar + popüler ürünler)
 * Yazıldığında → predictive search sonuçları (ürün + yazım önerileri)
 *
 * Hız: 180ms debounce, AbortController ile eski istek iptali, oturum içi önbellek,
 *      öneri görselleri width parametresiyle küçültülür (tam boyut indirme yapılmaz).
 */
(function () {
  'use strict';

  var input = document.getElementById('tySearchInput');
  var dropdown = document.getElementById('tySearchDropdown');
  if (!input || !dropdown) return;

  var searchForm = document.getElementById('tySearchForm');
  var backBtn = document.getElementById('tySearchBack');
  var debounceTimer;
  var currentQuery = '';
  var controller = null;            // aktif fetch'i iptal etmek için
  var cache = new Map();            // sorgu → sonuç önbelleği (oturum içi)
  var CACHE_MAX = 40;
  var RECENT_KEY = 'ty_recent_searches';
  var RECENT_MAX = 6;
  var activeIndex = -1;

  function getOptions() {
    return Array.from(dropdown.querySelectorAll('[data-ty-option]'));
  }

  function resetActiveOption() {
    getOptions().forEach(function (option) {
      option.classList.remove('is-keyboard-active');
      option.setAttribute('aria-selected', 'false');
    });
    activeIndex = -1;
    input.removeAttribute('aria-activedescendant');
  }

  function prepareOptions() {
    activeIndex = -1;
    input.removeAttribute('aria-activedescendant');
    var selector = '[data-ty-result], [data-ty-query], [data-ty-recent-q], [data-ty-retry], a.ty-discover-cat, .ty-search-view-all';
    dropdown.querySelectorAll(selector).forEach(function (option, index) {
      option.dataset.tyOption = 'true';
      option.id = 'ty-search-option-' + index;
      option.setAttribute('role', 'option');
      option.setAttribute('aria-selected', 'false');
      option.setAttribute('tabindex', '-1');
    });
  }

  function moveActiveOption(direction) {
    var options = getOptions();
    if (!options.length) return;
    activeIndex = (activeIndex + direction + options.length) % options.length;
    options.forEach(function (option, index) {
      var selected = index === activeIndex;
      option.classList.toggle('is-keyboard-active', selected);
      option.setAttribute('aria-selected', selected ? 'true' : 'false');
    });
    input.setAttribute('aria-activedescendant', options[activeIndex].id);
    options[activeIndex].scrollIntoView({ block: 'nearest' });
  }

  // Dropdown açık/kapalı durumunu search box'a yansıt
  function syncOpenClass() {
    if (!searchForm) return;
    if (dropdown.style.display === 'block') {
      searchForm.classList.add('ty-search--open');
    } else {
      searchForm.classList.remove('ty-search--open');
    }
  }

  function showDropdown() {
    dropdown.style.display = 'block';
    input.setAttribute('aria-expanded', 'true');
    syncOpenClass();
    requestAnimationFrame(syncDropdownViewport);
  }

  function syncDropdownViewport() {
    if (fsOpen()) {
      dropdown.style.removeProperty('max-height');
      return;
    }
    var available = window.innerHeight - dropdown.getBoundingClientRect().top - 16;
    dropdown.style.maxHeight = Math.max(120, Math.min(540, available)) + 'px';
  }

  function hideDropdown() {
    dropdown.style.display = 'none';
    input.setAttribute('aria-expanded', 'false');
    resetActiveOption();
    syncOpenClass();
  }

  // ===== TAM EKRAN MOBİL ARAMA =====
  // Mobilde inputa odaklanınca arama sayfa gibi tam ekran açılır (CSS: .ty-search--fs).
  // ÖNEMLİ: Form body'ye taşınır (reparent). Header zincirinde transform/animation
  // (örn. row2'nin tySearchSlide açılış animasyonu) varken position:fixed viewport'a
  // değil o atalara göre konumlanıyordu — overlay ekranı tam kaplamıyordu.
  var fsPlaceholder = null;
  function isFsViewport() { return window.innerWidth <= 989; }
  function fsOpen() { return searchForm && searchForm.classList.contains('ty-search--fs'); }
  function openFullscreen() {
    if (!searchForm || !isFsViewport() || fsOpen()) return;
    fsPlaceholder = document.createComment('ty-search-fs-placeholder');
    searchForm.parentNode.insertBefore(fsPlaceholder, searchForm);
    document.body.appendChild(searchForm);
    searchForm.classList.add('ty-search--fs');
    document.body.classList.add('ty-search-fs-open');
    // Eski satır-içi çubuk asla ara kare olarak görünmesin
    var row2 = document.querySelector('.ty-header__row2');
    if (row2) row2.classList.remove('is-open');
    // İçerik hemen gelsin (odak beklemeden): sorgu varsa sonuçlar, yoksa Keşfet
    var q = input.value.trim();
    if (q.length >= 2) { fetchSuggestions(q); } else { renderDiscover(); }
    // Taşıma sırasında odak düşer; klavyeyi geri getir
    requestAnimationFrame(function () { input.focus(); });
  }
  function closeFullscreen(restoreFocus) {
    if (!searchForm) return;
    if (restoreFocus !== false) restoreFocus = true;
    searchForm.classList.remove('ty-search--fs');
    document.body.classList.remove('ty-search-fs-open');
    if (fsPlaceholder && fsPlaceholder.parentNode) {
      fsPlaceholder.parentNode.insertBefore(searchForm, fsPlaceholder);
      fsPlaceholder.parentNode.removeChild(fsPlaceholder);
    }
    fsPlaceholder = null;
    hideDropdown();
    input.blur();
    // Header durumunu temizle
    var row2 = document.querySelector('.ty-header__row2');
    if (row2) row2.classList.remove('is-open');
    var tgl = document.getElementById('tyMobileSearchToggle');
    if (tgl) tgl.setAttribute('aria-expanded', 'false');
    if (restoreFocus && tgl) {
      requestAnimationFrame(function () {
        if (tgl.isConnected) tgl.focus({ preventScroll: true });
      });
    }
  }
  // Header'daki arama ikonunun doğrudan tam ekran açabilmesi için dışa açılan API
  window.tySearch = { openFullscreen: openFullscreen, closeFullscreen: closeFullscreen };

  // KRİTİK — bfcache koruması: Kullanıcı tam ekran aramadan bir ürüne gidip GERİ
  // dönerse, tarayıcı sayfayı bfcache'ten aynen geri yükler → overlay açık ve gövde
  // kaydırması kilitli kalır (müşteri "donmuş sayfa" görür ve terk eder).
  // Sayfa her gösterildiğinde ve sayfadan ayrılırken tam ekran durumu temizlenir.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && fsOpen()) closeFullscreen(false);
    // persisted olmasa da body kilidi artık kalmışsa temizle (güvenlik ağı)
    if (!fsOpen() && document.body.classList.contains('ty-search-fs-open')) {
      document.body.classList.remove('ty-search-fs-open');
    }
  });
  window.addEventListener('pagehide', function () {
    if (fsOpen()) closeFullscreen(false);
  });

  // ===== GÖRSEL BOYUTLANDIRMA =====
  // suggest.json ürün görselini TAM BOYUT döndürür; 44px önizleme için
  // CDN'den küçük varyant istenmeli, yoksa mobil megabaytlarca indirir.
  function sizedImage(url, width) {
    if (!url) return '';
    url = String(url);
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  // ===== PARA FORMATLAMA =====
  function parsePrice(val) {
    if (!val && val !== 0) return 0;
    var str = String(val).trim();
    // Eğer nokta veya virgül varsa, zaten bölünmüş/formatlanmış kabul et
    var isDivided = str.includes('.') || str.includes(',');
    var num = parseFloat(str.replace(/[^0-9.-]+/g, ""));
    if (isNaN(num)) return 0;
    return isDivided ? num : num / 100;
  }

  function formatMoney(val) {
    var amount = parsePrice(val);
    var formatted = amount.toFixed(2).replace('.', ',');
    var parts = formatted.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    formatted = parts.join(',');
    return formatted + ' ₺';
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ===== SON ARAMALAR =====
  function getRecent() {
    try {
      var r = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(r) ? r : [];
    } catch (_) { return []; }
  }
  function saveRecent(q) {
    q = (q || '').trim();
    if (q.length < 2) return;
    try {
      var r = getRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
      r.unshift(q);
      localStorage.setItem(RECENT_KEY, JSON.stringify(r.slice(0, RECENT_MAX)));
    } catch (_) {}
  }
  function clearRecent() {
    try { localStorage.removeItem(RECENT_KEY); } catch (_) {}
  }

  // ===== KEŞFET VERİLERİ (Liquid ile enjekte edilir) =====
  var discoverData = null;
  try {
    var el = document.getElementById('tyDiscoverData');
    if (el) discoverData = JSON.parse(el.textContent);
  } catch (e) { /* ignore */ }

  var discoverLabels = discoverData && discoverData.labels ? discoverData.labels : {};
  function searchLabel(key, fallback) {
    return discoverLabels[key] || fallback;
  }

  function discoverIconSvg(name, size) {
    var paths = {
      sparkles: '<path d="m12 3 1.15 3.35L16.5 7.5l-3.35 1.15L12 12l-1.15-3.35L7.5 7.5l3.35-1.15L12 3Z"/><path d="m18 13 .8 2.2L21 16l-2.2.8L18 19l-.8-2.2L15 16l2.2-.8L18 13Z"/><path d="m5.5 12 .65 1.85L8 14.5l-1.85.65L5.5 17l-.65-1.85L3 14.5l1.85-.65L5.5 12Z"/>',
      flame: '<path d="M12 22c4.4 0 7-3.1 7-7.1 0-3.1-1.7-5.8-5-8.9.1 2.5-1.1 4.1-2.7 5.2.1-3.3-1.7-6.4-4.1-8.2.2 4.3-2.2 6.2-2.2 10.9C5 18.5 7.7 22 12 22Z"/><path d="M9.5 18.5c0-1.9 1.1-3.2 2.8-4.5 0 1.4.8 2.3 1.7 3.2 0 1.6-.8 2.8-2.3 2.8-1.3 0-2.2-.7-2.2-1.5Z"/>',
      dress: '<path d="M9 3h6l1 5 4 11H4L8 8l1-5Z"/><path d="M8 8h8"/><path d="M10 3c0 1.2.8 2 2 2s2-.8 2-2"/>',
      ruler: '<rect x="3" y="6" width="18" height="12" rx="3"/><path d="M7 6v4M11 6v3M15 6v4M19 6v3"/>',
      bag: '<path d="M5 8h14l1 13H4L5 8Z"/><path d="M9 9V6a3 3 0 0 1 6 0v3"/>',
      shirt: '<path d="m8 4-5 3 3 5 2-1v10h8V11l2 1 3-5-5-3a4 4 0 0 1-8 0Z"/>',
      tag: '<path d="M20 13 13 20a2 2 0 0 1-3 0l-7-7V4h9l8 8a1.5 1.5 0 0 1 0 1Z"/><circle cx="7.5" cy="8.5" r="1"/>',
      book: '<path d="M4 5a3 3 0 0 1 3-3h5v18H7a3 3 0 0 0-3 2V5Z"/><path d="M20 5a3 3 0 0 0-3-3h-5v18h5a3 3 0 0 1 3 2V5Z"/>',
      truck: '<path d="M3 5h11v11H3V5Z"/><path d="M14 9h4l3 4v3h-7V9Z"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/>'
    };
    var iconSize = size || 20;
    return '<svg class="ty-discover-icon" width="' + iconSize + '" height="' + iconSize + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (paths[name] || paths.sparkles) + '</svg>';
  }

  function productRowHtml(p, mode) {
    var isDiscover = mode === 'discover';
    var img = sizedImage(p.image || (p.featured_image && p.featured_image.url), isDiscover ? 180 : 140);
    var pPrice = parsePrice(p.price);
    var pCompare = parsePrice(p.compare_at_price || p.compare_price);
    var priceHtml = '';

    if (pCompare > pPrice) {
      var discountPct = Math.round((1 - pPrice / pCompare) * 100);
      priceHtml = '<span class="ty-search-result__price ty-search-result__price--sale">' + formatMoney(p.price) + '</span>' +
        '<span class="ty-search-result__price ty-search-result__price--compare">' + formatMoney(pCompare) + '</span>';
      if (discountPct > 0) {
        priceHtml += '<span class="ty-search-result__discount-badge">%' + discountPct + '</span>';
      }
    } else {
      priceHtml = '<span class="ty-search-result__price">' + formatMoney(p.price) + '</span>';
    }

    return '<a href="' + p.url + '" class="ty-search-result' + (isDiscover ? ' ty-search-result--discover' : '') + '" data-ty-result>' +
      (img ? '<img class="ty-search-result__img" src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="58" height="76">' : '<div class="ty-search-result__img"></div>') +
      '<div class="ty-search-result__info">' +
        '<div class="ty-search-result__title">' + escapeHtml(p.title) + '</div>' +
        '<div class="ty-search-result__price-wrapper">' + priceHtml + '</div>' +
      '</div><span class="ty-search-result__arrow" aria-hidden="true">→</span></a>';
  }

  // ===== KEŞFET PANELİ =====
  function buildDiscoverHTML() {
    var html = '';
    var recent = getRecent();

    html += '<div class="ty-discover-shell">' +
      '<div class="ty-discover-header">' +
        '<span class="ty-discover-header__icon">' + discoverIconSvg('sparkles', 20) + '</span>' +
        '<span class="ty-discover-header__copy"><strong>' + escapeHtml(searchLabel('discover', 'Keşfet')) + '</strong>' +
        '<small>' + escapeHtml(searchLabel('discover_hint', 'Aradığın stile hızlıca ulaş')) + '</small></span>' +
      '</div>';

    if (recent.length) {
      html += '<div class="ty-discover-section ty-discover-section--recent">';
      html += '<div class="ty-discover-section-title">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>' +
        escapeHtml(searchLabel('recent', 'Son aramalar')) +
        '<button type="button" class="ty-discover-clear" data-ty-clear-recent>' + escapeHtml(searchLabel('clear', 'Temizle')) + '</button></div>';
      html += '<div class="ty-discover-cats ty-discover-cats--recent">';
      recent.forEach(function (q) {
        html += '<button type="button" class="ty-discover-cat" data-ty-recent-q="' + escapeHtml(q) + '">' +
          '<span class="ty-discover-cat__icon">' + discoverIconSvg('sparkles', 16) + '</span>' +
          '<span class="ty-discover-cat__name">' + escapeHtml(q) + '</span>' +
        '</button>';
      });
      html += '</div></div>';
    }

    if (!discoverData) return html + '</div>';

    var hasPopular = Boolean(discoverData.popular && discoverData.popular.length);
    html += '<div class="ty-discover-layout' + (hasPopular ? '' : ' ty-discover-layout--categories-only') + '">';
    if (discoverData.collections && discoverData.collections.length) {
      html += '<div class="ty-discover-section ty-discover-section--categories">';
      html += '<div class="ty-discover-cats">';
      discoverData.collections.forEach(function (c) {
        html += '<a href="' + c.url + '" class="ty-discover-cat" data-discover-icon="' + escapeHtml(c.icon || 'sparkles') + '">' +
          '<span class="ty-discover-cat__icon">' + discoverIconSvg(c.icon, 20) + '</span>' +
          '<span class="ty-discover-cat__name">' + escapeHtml(c.title) + '</span>' +
          '<span class="ty-discover-cat__arrow" aria-hidden="true">→</span>' +
        '</a>';
      });
      html += '</div></div>';
    }

    if (hasPopular) {
      html += '<div class="ty-discover-section ty-discover-section--popular">';
      html += '<div class="ty-discover-section-title ty-discover-section-title--popular">' +
        '<span class="ty-discover-section-title__icon">' + discoverIconSvg('flame', 17) + '</span>' +
        '<span><strong>' + escapeHtml(searchLabel('popular', 'Bu ara çok sevilenler')) + '</strong>' +
        '<small>' + escapeHtml(searchLabel('popular_hint', 'Müşterilerin en çok incelediği ürünler')) + '</small></span></div>';
      html += '<div class="ty-discover-products">';
      discoverData.popular.slice(0, 4).forEach(function (p) {
        html += productRowHtml(p, 'discover');
      });
      html += '</div>';
      if (discoverData.popular_url) {
        html += '<a href="' + discoverData.popular_url + '" class="ty-search-view-all ty-discover-view-all">' +
          escapeHtml(searchLabel('view_popular', 'Tüm çok satanları gör')) + '<span aria-hidden="true">→</span></a>';
      }
      html += '</div>';
    }

    return html + '</div></div>';
  }

  function renderDiscover() {
    var html = buildDiscoverHTML();
    if (!html) { hideDropdown(); return; }
    dropdown.classList.remove('has-product-results');
    dropdown.innerHTML = html;
    prepareOptions();
    showDropdown();
  }

  // ===== ARAMA SONUÇLARI =====
  function renderResults(data) {
    var html = '';
    var results = data && data.resources && data.resources.results;
    var hasProducts = Boolean(results && results.products && results.products.length);

    // Yazım / arama önerileri ("abye" → "abiye")
    if (results && results.queries && results.queries.length) {
      var chips = '';
      results.queries.slice(0, 4).forEach(function (q) {
        if (!q.text || q.text.toLowerCase() === currentQuery.toLowerCase()) return;
        chips += '<button type="button" class="ty-search-query-chip" data-ty-query="' + escapeHtml(q.text) + '">' +
          (q.styled_text || escapeHtml(q.text)) + '</button>';
      });
      if (chips) {
        html += '<div class="ty-search-queries">' + chips + '</div>';
      }
    }

    if (hasProducts) {
      html += '<div class="ty-search-results-scroll"><div class="ty-search-section-title">' + escapeHtml(searchLabel('products', 'Ürünler')) + '</div>';
      results.products.slice(0, 8).forEach(function (p) {
        html += productRowHtml(p);
      });
      html += '</div><a href="/search?q=' + encodeURIComponent(currentQuery) + '&type=product&options%5Bprefix%5D=last" class="ty-search-view-all">' +
        escapeHtml(searchLabel('view_all', '“__QUERY__” için tüm sonuçları gör').replace('__QUERY__', currentQuery)) + '<span aria-hidden="true">→</span></a>';
    }

    if (!html) {
      html = '<div class="ty-search-no-results">' + discoverIconSvg('sparkles', 24) +
        '<strong>' + escapeHtml(searchLabel('no_results', '“__QUERY__” için sonuç bulunamadı').replace('__QUERY__', currentQuery)) + '</strong></div>' +
        buildDiscoverHTML();
    }

    dropdown.classList.toggle('has-product-results', hasProducts);
    dropdown.innerHTML = html;
    prepareOptions();
    showDropdown();
  }

  // ===== ARAMA FETCH =====
  function fetchSuggestions(q) {
    currentQuery = q;
    if (q.length < 2) {
      if (controller) { controller.abort(); controller = null; }
      renderDiscover();
      return;
    }

    // Önbellek: aynı sorgu tekrar yazıldıysa ağa çıkma
    var cacheKey = q.toLowerCase();
    if (cache.has(cacheKey)) {
      renderResults(cache.get(cacheKey));
      return;
    }

    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,query' +
      '&resources[limit]=8' +
      '&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=hide' +
      '&resources[options][prefix]=last';

    // Skeleton loading (sadece önbellekte yoksa görünür)
    var skeletonHtml = '<div class="ty-search-skeleton">';
    for (var i = 0; i < 5; i++) {
      skeletonHtml += '<div class="ty-search-skeleton__item">' +
        '<div class="ty-search-skeleton__img skeleton-shimmer"></div>' +
        '<div class="ty-search-skeleton__info">' +
          '<div class="ty-search-skeleton__line ty-search-skeleton__line--mid skeleton-shimmer"></div>' +
          '<div class="ty-search-skeleton__line ty-search-skeleton__line--short skeleton-shimmer"></div>' +
        '</div>' +
      '</div>';
    }
    skeletonHtml += '</div>';
    dropdown.classList.remove('has-product-results');
    dropdown.innerHTML = skeletonHtml;
    showDropdown();

    // Eski isteği gerçekten iptal et (bant genişliğini yeni isteğe bırak)
    if (controller) controller.abort();
    controller = new AbortController();

    fetch(url, { signal: controller.signal })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        if (cache.size >= CACHE_MAX) cache.delete(cache.keys().next().value);
        cache.set(cacheKey, data);
        if (currentQuery === q) renderResults(data);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return; // yenisi yolda, dokunma
        if (currentQuery !== q) return;
        dropdown.classList.remove('has-product-results');
        dropdown.innerHTML = '<div class="ty-search-no-results" role="status">' + discoverIconSvg('sparkles', 24) +
          '<strong>' + escapeHtml(searchLabel('load_error', 'Arama şu anda yüklenemiyor.')) + '</strong></div>' +
          '<button type="button" class="ty-search-view-all" data-ty-retry>' + escapeHtml(searchLabel('retry', 'Tekrar dene')) + '</button>';
        prepareOptions();
        showDropdown();
      });
  }

  // ===== EVENT LISTENERS =====
  input.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    var q = input.value.trim();
    debounceTimer = setTimeout(function () { fetchSuggestions(q); }, 180);
  });

  input.addEventListener('focus', function () {
    openFullscreen();
    var q = input.value.trim();
    if (q.length >= 2) {
      showDropdown();
    } else {
      renderDiscover();
    }
  });

  if (backBtn) {
    backBtn.addEventListener('click', function () {
      closeFullscreen();
    });
  }

  // Dropdown içi tıklamalar: öneri chip'i, son arama, temizle, sonuç linki
  dropdown.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-ty-query]');
    if (chip) {
      var q = chip.getAttribute('data-ty-query');
      input.value = q;
      input.focus();
      saveRecent(q);
      fetchSuggestions(q);
      return;
    }
    var recentBtn = e.target.closest('[data-ty-recent-q]');
    if (recentBtn) {
      var rq = recentBtn.getAttribute('data-ty-recent-q');
      input.value = rq;
      input.focus();
      fetchSuggestions(rq);
      return;
    }
    if (e.target.closest('[data-ty-clear-recent]')) {
      clearRecent();
      renderDiscover();
      return;
    }
    if (e.target.closest('[data-ty-retry]')) {
      fetchSuggestions(input.value.trim());
      return;
    }
    if (e.target.closest('[data-ty-result]')) {
      saveRecent(currentQuery);
      // navigasyon linkin kendisiyle devam eder
    }
    // Dropdown içinden HERHANGİ bir linke tıklanınca tam ekranı kapat ki
    // bfcache anlık görüntüsü temiz kalsın (geri dönüşte kilitli overlay kalmasın).
    if (fsOpen() && e.target.closest('a[href]')) {
      closeFullscreen(false);
    }
  });

  if (searchForm) {
    searchForm.addEventListener('submit', function () {
      saveRecent(input.value);
    });
    searchForm.addEventListener('keydown', function (event) {
      if (!fsOpen()) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeFullscreen();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = Array.from(searchForm.querySelectorAll('button:not([disabled]), input:not([disabled])')).filter(function (element) {
        var style = window.getComputedStyle(element);
        return style.display !== 'none' && style.visibility !== 'hidden';
      });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  window.addEventListener('resize', function () {
    if (dropdown.style.display === 'block') syncDropdownViewport();
  });

  document.addEventListener('click', function (e) {
    if (fsOpen()) return; // tam ekranda dış tıklama yok; geri oku ile kapanır
    if (!input.contains(e.target) && !dropdown.contains(e.target)) {
      hideDropdown();
    }
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      if (dropdown.style.display !== 'block') {
        var q = input.value.trim();
        if (q.length >= 2) fetchSuggestions(q); else renderDiscover();
      }
      moveActiveOption(e.key === 'ArrowDown' ? 1 : -1);
      return;
    }
    if (e.key === 'Enter' && activeIndex >= 0) {
      var option = getOptions()[activeIndex];
      if (option) {
        e.preventDefault();
        option.click();
      }
      return;
    }
    if (e.key === 'Escape') {
      if (fsOpen()) { closeFullscreen(); return; }
      hideDropdown();
      input.blur();
    }
  });
})();
